// Recovered compiled webpack factory 78714. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  let n;
  r.d(t, { Qw: () => o, Wk: () => s, hY: () => i });
  var a = r(49636);
  function o(e) {
    if (void 0 !== n) return n ? n(e) : e();
    let t = Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__"),
      r = a.O;
    return t in r && "function" == typeof r[t] ? (n = r[t])(e) : ((n = null), e());
  }
  function i() {
    return o(() => Math.random());
  }
  function s() {
    return o(() => Date.now());
  }
}
